import { Component, OnInit, Renderer2, ViewChild, HostListener } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { Router,ActivatedRoute } from '@angular/router';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { ApiService } from "../../services/api.service";
import { ResourceService } from "../../services/resource.service";
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { Content } from "../../models/content";
import { VideoPoster } from "../../models/videoposter";
import { TextItem } from '../../models/videoposter';
import { ClipartItem } from '../../models/videoposter';
import { Background } from '../../models/videoposter';
import { COLORS } from '../../models/colors';

import { Player } from "../../models/player";

import { DrawingBoardComponent } from "../drawing-board/drawing-board.component";


@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss']
})
export class BodyComponent implements OnInit {

    @ViewChild(DrawingBoardComponent) drawingComponent:DrawingBoardComponent;


    state: string;
    errorMessage: string;
    errorTitle: string;
    //private poster: VideoPoster;
    content: Content;
    private players: Player[];

    //private warningTimerSubscription: Subscription;
    //private warningTimer: any;

    private portalID: string;
    private routeSubscription: Subscription;
    private disableNext = false;
    private disableBack = false;
    private disableCancel = false;
    private visitedBackgroundGallery = false;
    private visitedPosterGallery = false;
    private savedGalleryPage = 1; //if returning to gallery from drawing board
	  private savedPosterPage = 1;
    loadingAnimations = ANIMATION_TYPES;
    private showWindow = -1; // -1 = none, 0 = show clipart window, 1 = show color window

    // drawing sidebar vars:
    private clickedItem = -1; //index of selected clipart
    private selectedColorID = 31; //index of selected color. black by default. -1 when using sliders or text boxes.
    private inputColor = {r: 0, g: 0, b: 0};
    private _colors = COLORS;
    private _white = '#E9EFEF';
    private clipartJSON: JSON;
    private clipartPage: number;
    private clipartLength: number;
    private textProperties = {
      "fontFamily": "Arial",
      "bold": "normal",
      "italic": "normal",
      "align": "left",
      "size": 12,
      "color": "#000000"
    };
    primaryColor: any;
    secondaryColor: any;
    greeting: any;

    private summaryCanvasScale: number;


    private showWarning: Boolean;
    private showWarningSubscription: Subscription;
    private timeoutSubscription: Subscription;

    //private cmdSubmittable: boolean;

    constructor(private apiService: ApiService,
                private route: ActivatedRoute,
                private renderer: Renderer2,
                private _sanitizer: DomSanitizer,
                private resourceService: ResourceService) {
      this.state = "loading";
      this.disableNext = true;
      this.clipartPage = 1;
      this.clipartLength = 0;
      this.showWarning = false;
      this.summaryCanvasScale = 1;
    }

    ngOnInit() {
      /*this.warningTimerSubscription = this.apiService.getShowWarning()
        .subscribe( timer => {
          this.warningTimer = timer;
        });*/

      this.routeSubscription = this.route.queryParams.subscribe(params => {
        this.portalID = params['id'];
        if(!this.portalID || Object.keys(params).length == 0){
          this.state = "error";
          this.errorTitle = "Error";
          this.errorMessage = "Invalid URL";
        } else{
          if(this.portalID != "cmd"){
            this.content = new Content();
            this.content.portalURL = this.portalID;
            this.apiService.validatePortalURL(this.content)
            .then(
              content => {
                if(content && content.status){
                  this.content = content;
                  if(this.content.hasGuest && !this.content.hasUsers){
                    this.guestLogin(true);
                    this.primaryColor = this.content.portal.primaryColor;
                    this.secondaryColor = this.content.portal.secondaryColor;
                    this.greeting = this.content.portal.greeting;
                  } if(!this.content.hasGuest && !this.content.hasUsers){
                    this.content = new Content();
                    this.state = "error";
                    this.errorTitle = "Error";
                    this.errorMessage = "No User/Guest assigned"
                  }else{
                    this.primaryColor = this.content.portal.primaryColor;
                    this.secondaryColor = this.content.portal.secondaryColor;
                    this.greeting = this.content.portal.greeting;
                    this.state = "login";
                  }
                } else{
                  this.state = "error";
                  this.errorTitle = "Error";
                  this.errorMessage = this.content.message;
                }
              },
              err => {
                this.state = "error";
                this.errorTitle = "Error";
                this.errorMessage = "Invalid URL";
                if(err) console.log(err);
              }
            )
          } else{
            this.content = new Content();
            this.content.portalURL = null;
            if(localStorage.getItem("token")){
              this.apiService.validateCommanderPortalURL(this.content)
              .then(
                content => {
                  if(content && content.status){
                    this.content = content;
                    if(this.content.superUser){
                      this.state = "create";
                      this.primaryColor = '#282b31';
                      this.secondaryColor = '#4fa0c2';
                      this.greeting = "Super User Greeting";
                    } else{
                      this.state = "error";
                      this.errorTitle = "Error";
                      this.errorMessage = this.content.message;
                    }
                  } else{
                    this.state = "error";
                    this.errorTitle = "Error";
                    this.errorMessage = this.content.message;
                  }
                },
                err => {
                  this.state = "error";
                  this.errorTitle = "Session Expired";
                  this.errorMessage = "Please Login to Commander";
                  if(err) console.log(err);
                }
              )
            } else{
              this.state = "error";
              this.errorTitle = "Error";
              this.errorMessage = "Invalid URL";
            }
            
          }
        }
     });
    }

    ngAfterViewInit(){

    }

    userUpdate(content){
      this.content = content;
      if(this.content.username && this.content.password){
        this.disableNext = false;
      }
    }

    guestLogin(flag){
      if(flag){
        this.state = "loading";
        this.apiService.guestLogin(this.content)
        .then(
          content => {
            this.content = content;
            if(this.content.status){
              this.content.username = "guest";
              this.content.password = "guest";
              this.state = "create";
              this.resetTimer();
              //this.apiService.setTime(this.content.portal.inactivityTime, this.content.portal.warningTime);
            } else{
              this.state = "login";
            }
          },
          err => {
            this.content = err;
            this.state = "login";
          }
        )
      }
    }

    gotoBackgroundGallery(){
      this.disableNext = true;
      this.state = "gallery-background";
      this.visitedBackgroundGallery = true;
    }
    gotoPosterGallery(){
      this.disableNext = true;
      this.state = "gallery-poster";
      this.visitedPosterGallery = true;
    }

    gotoImport(){
      this.disableNext = true;
      this.state = "browse";
    }

    backgroundSelected(resource){
      this.state = "loading";
      if(!resource.mainPreview){
        var self = this;
        this.resourceService.getResourceThumbPreview(resource)
        .subscribe((res) => {
          resource.imageData = res;
          resource.mainPreview = self._sanitizer.bypassSecurityTrustResourceUrl(res);
          //resource.mainPreview = self._sanitizer.bypassSecurityTrustResourceUrl(res);
          self.content.videoPoster = new VideoPoster(100,100, new Background(resource.mainPreview, resource.imageData));
          self.state = "drawing";
          self.disableNext = false;
          self.visitedBackgroundGallery = true;
        });
      } else{
        this.content.videoPoster = new VideoPoster(100,100, new Background(resource.mainPreview, resource.imageData));
        this.state = "drawing";
        this.disableNext = false;
        this.visitedBackgroundGallery = true;
      }
    }

    posterSelected(poster){
      this.state = "loading";
      this.apiService.getVideoPosterShow(poster.posterID, this.content)
      .then(vp=>{
        console.log(vp);
        this.content.videoPoster = vp;
        this.state = "drawing";
        this.disableNext = false;
        this.visitedPosterGallery = true;
      }, err=>{
        console.log(err);
        this.state = "false";
        this.errorTitle = "Session Expired";
        this.errorMessage = "Please Login to Commander";
      });
    }

    saveGalleryPage(n: number){
      this.savedGalleryPage = n;
    }

		savePosterPage(n: number){
			this.savedPosterPage = n;
		}

    browseFileSelected(imageData: any){
     // this.poster = new VideoPoster(100,100, new Background(imageData));
      this.content.videoPoster = new VideoPoster(100,100, new Background(imageData, imageData));
      this.state = "drawing";
      this.disableNext = false;
    }

    addText(){
      var text = new TextItem(this.content.videoPoster.getNewItemID(), 0, 0, 100, 100, "Text", "Arial", 36, "left", "normal", "normal");
      let maxDim = this.content.videoPoster.width > this.content.videoPoster.height ? this.content.videoPoster.width : this.content.videoPoster.height;if(maxDim > 1500){
        text.setFontSize(100);
        text.setHeight(150);
        text.setWidth(300);
      }
      else if(maxDim > 1000){
        text.setFontSize(60);
        text.setHeight(100);
        text.setWidth(200);
      }
      else if(maxDim > 600){
        text.setFontSize(48);
        text.setHeight(84);
        text.setWidth(150);
      }
      else{
        text.setFontSize(36);
        text.setHeight(60);
        text.setWidth(84);
      }
      this.content.videoPoster.addItem(text);
      this.content.videoPoster.setItemSelected(text.id);
      this.renderer.removeClass(<HTMLInputElement>document.getElementById('text-properties'), 'closed');
      this.renderer.addClass(<HTMLInputElement>document.getElementById('text-properties'), 'open');
      this.setTextAlign('left');
      this.inputColor={r:0,g:0,b:0};
      this.setTextColor();
    }
    setFontFamily(ff){
      //var item = this.poster.getItemSelected();
      var item = this.content.videoPoster.getItemSelected();
      if(item instanceof TextItem){
        (<TextItem>item).setFontFamily(ff);
      }
    }
    setFontSize(fs){
      //var item = this.poster.getItemSelected();
      var item = this.content.videoPoster.getItemSelected();
      if(item instanceof TextItem){
        (<TextItem>item).setFontSize(fs * this.content.videoPoster.canvasScale);
      }
    }
    setTextColor(){
      //var item = this.poster.getItemSelected();
      var item = this.content.videoPoster.getItemSelected();
      if(item instanceof TextItem){
        (<TextItem>item).setColor(this.rgbToHex(this.inputColor));
      }
      this.toggleModal(-1);
    }
    setTextWeight(){
      //var item = this.poster.getItemSelected();
      var item = this.content.videoPoster.getItemSelected();
      let btn = <HTMLInputElement>document.getElementById('button-bold');
      if(item instanceof TextItem){
        if((<TextItem>item).getWeight().toLowerCase() == 'bold'){
          (<TextItem>item).setWeight("normal");
          this.renderer.setStyle(btn, 'background-color', this.secondaryColor);
          this.renderer.setStyle(btn, 'color', this._white);
        } else{
          (<TextItem>item).setWeight("bold");
          this.renderer.setStyle(btn, 'background-color', this._white);
          this.renderer.setStyle(btn, 'color', this.secondaryColor);
        }
      }
    }
    setTextStyle(){
      //var item = this.poster.getItemSelected();
      var item = this.content.videoPoster.getItemSelected();
      let btn = <HTMLInputElement>document.getElementById('button-italic');
      if(item instanceof TextItem){
        if((<TextItem>item).getStyle().toLowerCase() == 'italic'){
          (<TextItem>item).setStyle("normal");
          this.renderer.setStyle(btn, 'background-color', this.secondaryColor);
          this.renderer.setStyle(btn, 'color', this._white);
        } else{
          (<TextItem>item).setStyle("italic");
          this.renderer.setStyle(btn, 'background-color', this._white);
          this.renderer.setStyle(btn, 'color', this.secondaryColor);
        }
      }
    }
    setTextAlign(a){
      //var item = this.poster.getItemSelected();
      var item = this.content.videoPoster.getItemSelected();
      let btns = [
          <HTMLInputElement>document.getElementById('button-left'),
          <HTMLInputElement>document.getElementById('button-center'),
          <HTMLInputElement>document.getElementById('button-right')
      ];
      if(item instanceof TextItem){
        (<TextItem>item).setAlign(a);
        for (let i in btns){
          if (('button-'+a) == btns[i].id){
            this.renderer.setStyle(btns[i], 'background-color', this._white);
            this.renderer.setStyle(btns[i], 'color', this.secondaryColor);
          }
          else{
            this.renderer.setStyle(btns[i], 'background-color', this.secondaryColor);
            this.renderer.setStyle(btns[i], 'color', this._white);
          }
        }
      }
    }

    addClipart(resource){
      //var clip = new ClipartItem(this.poster.getNewItemID(), 0, 0, 100, 100, resource.mainPreview);
      //this.poster.addItem(clip);
      var clip = new ClipartItem(this.content.videoPoster.getNewItemID(), 0, 0, 100, 100, resource.mainPreview, resource.mainPreview);
      this.content.videoPoster.addItem(clip);
    }
    deleteItem(){
      //var item = this.poster.getItemSelected();
      var item = this.content.videoPoster.getItemSelected();
      if(item){
        //this.poster.removeItem(item.getId());
        this.content.videoPoster.removeItem(item.getId());
      }
    }

    contentTimingUpdate(){
      if(this.content && this.content.startDate && this.content.endDate){
        this.disableNext = false;
      } else{
        this.disableNext = true;
      }
    }
    contentPlayersUpdate(){
      if(this.content && this.content.players && this.content.players.length > 0){
        this.disableNext = false;
      } else{
        this.disableNext = true;
      }
    }

    onNext(){
      var self = this;
      if(this.state == "login"){
        this.state = "loading";
        this.apiService.login(this.content)
        .then(
          content => {
            this.content = content;
            if(this.content.status){
              this.state = "create";
              this.resetTimer();
            } else{
              this.state = "login";
            }
          },
          err => {
            this.content = err;
            this.state = "login";
          }
        )
      } else if(this.state == "create"){
        this.disableNext = true;
        this.visitedBackgroundGallery = false;
        this.visitedPosterGallery = false;
      } else if( this.state == "drawing"){
        this.disableNext = true;
        this.state = "loading";
        var poster = this.drawingComponent.getPoster();
        this.content.width = poster.width;
        this.content.height = poster.height;
        this.drawingComponent.getCanvasImage().then(function(canvas){
          self.content.imageData = canvas.toDataURL();
          self.state = "timing"
        });
      } else if(this.state == "timing"){
        this.state = "loading";
        this.apiService.getPlayersForUser(this.content)
        .then(
          players => {
            this.players = players;
            this.disableNext = true;
            this.state = "players";
          },
          err=>{
            if(err.status == 403){
              this.state = "error";
              this.errorTitle = "Session Expired";
              this.errorMessage = "Please Login to Commander";
            }
          }
        );
      } else if(this.state == "players"){
        this.disableNext = false;
        this.state = "summary";
      } else if(this.state == "summary" && !this.content.submissionID){
        this.state = "loading";
        this.apiService.submit(this.content)
        .then(
          con => {
            this.content = con;
            console.log(this.content);
            if(this.content.submissionID){
              this.state = "summary";
            } else{
              if(this.content.superUser){
                this.state = "create";
              } else{
                this.state = "login";
              }
            }
          },
          err => {
            if(err.status == 403){
              this.state = "error";
              this.errorTitle = "Session Expired";
              this.errorMessage = "Please Login to Commander";
            } else{
              this.state = "login";
            }
          }
        )
      } else if(this.state == "summary" && this.content.submissionID){
        if(this.content.superUser){
          this.content.resetToCreate();
          this.state = "create";
          this.visitedBackgroundGallery = false;
          this.visitedPosterGallery = false;
        } else{
          if(this.content.hasGuest && !this.content.hasUsers){
            this.content.resetToCreate();
            this.visitedBackgroundGallery = false;
            this.visitedPosterGallery = false;
            this.guestLogin(true);
            this.state = "create";
          } else{
            this.content.resetToLogin();
            this.state = "login";
            this.apiService.killTimer();
            this.visitedBackgroundGallery = false;
            this.visitedPosterGallery = false;
          }
        }
      }
    }

    onBack(){
      if(this.state == "gallery-background" || this.state == "gallery-poster" || this.state == "browse"){
        this.visitedBackgroundGallery = false;
        this.visitedPosterGallery = false;
        this.state = "create";
      } else if(this.state == "drawing"){
        if(this.visitedBackgroundGallery){
          this.state = "gallery-background";
        } else if(this.visitedPosterGallery){
          this.state = "gallery-poster";
        }else{
          this.state = "browse";
        }
      } else if(this.state == "timing"){
        this.state = "drawing";
      } else if(this.state == "players"){
        this.state = "timing";
      } else if(this.state == "summary" && !this.content.submissionID){
        if(this.content.players.length == 0){
          this.state = "drawing";
        } else{
          this.state = "players";
        }
      } else if(this.state == "summary" && this.content.submissionID){
        this.content.resetToCreate();
        this.state = "create";
      }
    }

    onSave(){
      if(this.content.superUser){
        this.content.players = [];
        this.disableNext = false;
        this.state = "loading";
        var poster = this.drawingComponent.getPoster();
        this.content.width = poster.width;
        this.content.height = poster.height;
        var self = this;
        this.drawingComponent.getCanvasImage().then(function(canvas){
          self.content.imageData = canvas.toDataURL();
          self.apiService.submit(self.content)
          .then(
            con => {
              self.content = con;
              if(self.content.submissionID){
                self.state = "summary";
              } else{
                if(self.content.superUser){
                  self.state = "create";
                } else{
                  self.state = "login";
                }
              }
            },
            err => {
              if(err.status == 403){
                self.state = "error";
                this.errorTitle = "Session Expired";
                self.errorMessage = "Please Login to Commander";
              } else{
                self.state = "login";
              }
            }
          );
        });
      }
    }

    onCancel(){
      if(this.content.superUser){
        this.content.resetToCreate();
        this.state = "create";
        this.visitedBackgroundGallery = false;
        this.visitedPosterGallery = false;
      } else if(this.state == "create" || this.state == "players" || this.state == "gallery-background" || this.state == "browse" || this.state == "drawing" || this.state == "timing"
         || (this.state == "summary" && !this.content.submissionID)){
          if(this.content.hasGuest && !this.content.hasUsers){
            this.content.resetToCreate();
            this.visitedBackgroundGallery = false;
            this.visitedPosterGallery = false;
            this.guestLogin(true);
            this.state = "create";
          } else{
            this.content.resetToLogin();
            this.state = "login";
            this.visitedBackgroundGallery = false;
            this.visitedPosterGallery = false;
            this.content.allPlayers = false;
          }
          //this.apiService.killTimer();
      } else if(this.state == "login"){
        if(this.content.hasGuest && !this.content.hasUsers){
          this.state = "create";
        } else{
          this.content.username = "";
          this.content.password = "";
          this.state = "login";
        }
      }
    }

    sessionClosed(flag){
      if(flag){
        this.state = "error";
        this.errorTitle = "Session Expired";
        this.errorMessage = "Please Login to Commander";
      }
    }

    toggleModal(n: number){
      if (n==0) {
        this.getNewClipart(1);
        this.resourceService.getResourcesPaginationInfo(2, this.content)
            .then(
              data => {
              this.clipartLength = data;
              }, err=>{
                if(err.status == 403){
                  this.state = "error";
                  this.errorTitle = "Session Expired";
                  this.errorMessage = "Please Login to Commander";
                }
              });
      }
      this.showWindow = n;
    }

    getClipartPagesArray(numItems: number, itemsPerPage: number): number[]{
      let pagesArray = [0]
      if (numItems < 1) return pagesArray;
      while (pagesArray.length < numItems/itemsPerPage) pagesArray.push(0);
      return pagesArray;
    }

    getNewClipart(pg: number){
      this.clipartPage = pg;
      this.resourceService.getResourcesForPage(pg, 10, 2, this.content)
          .then(clipart => {
            this.clipartJSON = clipart;
            for(var i in clipart){
              this.getPreviewImage(clipart[i]);
            }
          }, err=>{
            if(err.status == 403){
              this.state = "error";
              this.errorTitle = "Session Expired";
              this.errorMessage = "Please Login to Commander";
            }
          });
    }
    getPreviewImage(clipart): any{
      var self = this;
      if(clipart.mainPreview){
        return clipart.mainPreview;
      } else{
        this.resourceService.getResourcePreview(clipart)
        .subscribe((res) => {
          clipart.mainPreview = res;
          clipart.imageData = res;
        });
      }
      return true;
    }
    clickClipArt(item: number){
      this.clickedItem = item;
    }
    clickColor(item: number){
      this.selectedColorID = item;
      this.inputColor = this.hexToRgb(this._colors[item]);
    }
    channelChange(e: any){
      let channel = e.target.id.split("-")[1];
      if(e.target.id.substr(0,3)=='hex') {
        if (e.target.value.length == 1) e.target.value = 0 + e.target.value;
        let tempHex = {r: '00', g: '00', b: '00'};
        tempHex[channel] = e.target.value;
        this.inputColor[channel] = this.hexToRgb('#'+tempHex.r+tempHex.g+tempHex.b)[channel];
      }
      else this.inputColor[channel] = +e.target.value;
      //deselect standard color:
      if(this.selectedColorID > -1 && this.rgbToHex(this.inputColor) != this._colors[this.selectedColorID]) this.selectedColorID = -1;
    }
    selectClipart(n: number){
      const BASE_DIM = 175;
      //var clipart = new ClipartItem(this.poster.getNewItemID(), 0, 0, BASE_DIM, BASE_DIM, this.clipartJSON[n].mainPreview);
      var clipart = new ClipartItem(this.content.videoPoster.getNewItemID(), 0, 0, BASE_DIM, BASE_DIM, this.clipartJSON[n].mainPreview, this.clipartJSON[n].mainPreview);
      let temp = new Image();
      let comp = this;
      temp.src = clipart.imagePreview;
      temp.onload = function(){
        if(temp.width > temp.height)clipart.height = Math.round(BASE_DIM*temp.height/temp.width);
        else clipart.width = Math.round(BASE_DIM*temp.width/temp.height);
        //comp.poster.addItem(clipart);
        //comp.poster.setItemSelected(clipart.id);
        comp.content.videoPoster.addItem(clipart);
        comp.content.videoPoster.setItemSelected(clipart.id);
        comp.toggleModal(-1);
      }
    }

    isItemSelected(): boolean{
      //let item = this.poster.getItemSelected();
      //return this.poster.getItemSelected() ? true : false;
      let item = this.content.videoPoster.getItemSelected();
      return this.content.videoPoster.getItemSelected() ? true : false;
    }
    isTextItemSelected(): boolean{
      //let item = this.poster.getItemSelected();
      let item = this.content.videoPoster.getItemSelected();
      return item instanceof TextItem ? true : false;
    }

    isClipartItemSelected(): boolean{
      //let item = this.poster.getItemSelected();
      let item = this.content.videoPoster.getItemSelected();
      return item instanceof ClipartItem ? true : false;
    }

    getColor(attr: string, val: string): string{
      let color = false;
      let val2 = this.textProperties[val] ? val : 'align';
      if(val == 'color'){
        return this.textProperties[val];
      }
      else if (val == this.textProperties[val2]){
        if(attr == 'text'){
          color = true;
        }
      }
      else{
        if(attr == 'background'){
          color = true;
        }
      }
      return color ? this.secondaryColor : this._white;
    }

    resetTimer(){

    }

    isColorPickerClicked(e: any): any{
      if(!e.classList){ return false;}
      else return e.classList.contains('color-picker');
    }
/*
    overrideColorPickerDisplays(hex: string){
      let cpEl = document.getElementsByClassName("color-picker");
      if(!!cpEl && cpEl.length > 0){
        let ngCpEl = <HTMLInputElement>cpEl[0];
        // get rendered dom els to override
        let mainDisplayEl = ngCpEl['children'][1];
        let hueSliderEl = ngCpEl['children'][2]['children'][1]['children'][1]['children'][0];

        // get pure hue value
        let rgb = [];
        for (let n of this.hexToRgb(hex).split("(")[1].split(")")[0].split(",")){
          rgb.push(+n/255);
        }
        let hue = this.rgbToHsl(rgb[0],rgb[1],rgb[2])[0];

        //manually set bg color of main display element w/ pure hue
        let colorStr = 'hsl('+Math.floor(hue*360)+','+100+'%,'+50+'%)';
        this.renderer.setStyle(<HTMLInputElement>mainDisplayEl, 'background-color', colorStr);

        //manually set position of hue slider cursor
        let huePos = ((hue * 140) - 8)+"px"; // map intervals: from = [0,1], to = [-8,132]
        this.renderer.setStyle(<HTMLInputElement>hueSliderEl, 'left', huePos);

      }

    }
*/

  setTempCanvasScale(scale: number){
    this.summaryCanvasScale = scale;
  }

    addHeaderPadding(): boolean{
      // condition for repositioning header element. document attrs are only available in ts.
      // available body space == 48% document height as defined in variables.scss
      if(
        (this.state != 'drawing' && this.state != 'summary' && this.state != 'gallery-background' && this.state != 'gallery-poster') ||
        (this.state == 'summary' && !!this.content && this.content.height*this.summaryCanvasScale <= document.body.clientHeight * .65)
      ){ return true; }
      else return false;
    }

    @HostListener('document:click', ['$event'])
    onMouseDown(event: any): void{
      if(this.state != "login" && this.state != "loading"){
        this.resetTimer();
      }
      if(this.state == "drawing"){
        //let item = this.poster.getItemSelected();
        let item = this.content.videoPoster.getItemSelected();
        if (item && item instanceof TextItem){
          this.textProperties.fontFamily = item.getFontFamily();
          this.textProperties.bold = item.getWeight();
          this.textProperties.italic = item.getStyle();
          this.textProperties.align = item.getAlign();
          this.textProperties.size = item.getFontSize();
          this.textProperties.color = item.getColor();
        }
      }
    }

    @HostListener('document:touchstart', ['$event'])
    onTouch(event: any): void{
      if(this.state != "login" && this.state != "loading"){
        this.resetTimer();
      }
      if(this.state == "drawing"){
        //let item = this.poster.getItemSelected();
        let item = this.content.videoPoster.getItemSelected();
        if (!item && item instanceof TextItem){
          this.textProperties.fontFamily = item.getFontFamily();
          this.textProperties.bold = item.getWeight();
          this.textProperties.italic = item.getStyle();
          this.textProperties.align = item.getAlign();
          this.textProperties.size = item.getFontSize();
          this.textProperties.color = item.getColor();
        }
      }
    }

    @HostListener('keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
      if(event.keyCode == 13 && this.state == "login" && !this.disableNext){
        this.onNext();
      }
    }

// Color model convertors:
    rgbChannelToHex(ch: number){
      let hex = ch.toString(16);
      return hex.length == 1 ? "0" + hex : hex;
    }
    rgbToHex(color: {r: number, g: number, b:number}){
      return "#" + this.rgbChannelToHex(color.r) + this.rgbChannelToHex(color.g) + this.rgbChannelToHex(color.b);
    }
    hexToRgb(hex){
      let c;
      if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
          c= hex.substring(1).split('');
          if(c.length== 3){
              c= [c[0], c[0], c[1], c[1], c[2], c[2]];
          }
          c= '0x'+c.join('');
          //return 'rgb('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+')';
          return {r:(c>>16)&255, g: (c>>8)&255, b: c&255};
      }
    }
    rgbToHsl(r, g, b) {
      r /= 255, g /= 255, b /= 255;

      let max = Math.max(r, g, b), min = Math.min(r, g, b);
      let h, s, l = (max + min) / 2;

      if (max == min) {
        h = s = 0; // achromatic
      } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r: h = (g - b) / d + (g < b ? 6 : 0); break;
          case g: h = (b - r) / d + 2; break;
          case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
      }

      return [ h, s, l ];
    }

    hslToRgb(h, s, l) {
      let r, g, b;

      if (s == 0) {
        r = g = b = l; // achromatic
      } else {
        let q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        let p = 2 * l - q;

        r = this.hue2rgb(p, q, h + 1/3);
        g = this.hue2rgb(p, q, h);
        b = this.hue2rgb(p, q, h - 1/3);
      }

      return [ r * 255, g * 255, b * 255 ];
    }

    hue2rgb(p, q, t) {
       if (t < 0) t += 1;
       if (t > 1) t -= 1;
       if (t < 1/6) return p + (q - p) * 6 * t;
       if (t < 1/2) return q;
       if (t < 2/3) return p + (q - p) * (2/3 - t) * 6;
       return p;
     }
}



// WEBPACK FOOTER //
// ./src/app/components/body/body.component.ts